import { useContext, useEffect, useReducer, useState } from "react"
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion"
import { Get, Post2, PostSinContent } from "../Rutas/ApiRest"
import { Carga, cuentaCliente } from "../Rutas/Servicios"
import { tokens } from "../Context/Tokens"
import { Contexto } from "../Context/Contexto"
import { NotificacionesGeneral } from "../Context/Notificaciones_Context"
import { GuiaBusquedaCont } from "../Context/BusquedaGuiaContext"

export default function SoloFacturas(dato:any)
{
    const {tok}=useContext(tokens)
    const {Cli}=useContext(Contexto)
    const {SetMensajeEmergente,SetLoading}=useContext(MensajeContActualizacion)
    const extension1='.jpg'
    const extension2='.pdf'
    const extension3='.png'
    const extension4='.doc'
    const extension5='.docx'
    const [states,dispatch]=useReducer(reducer,{valor:0,descripcion:""})
    const [Url,SetUrl]=useState<string>("")
    const {ActualizarNotificacion}=useContext(NotificacionesGeneral)
    const {GuiaBusquedaPreAlerta}=useContext(GuiaBusquedaCont)
    const [Activo,SetActivo]=useState(true)
    var collapseId="flush-collapse"+dato.id;
    var idHeading="flush-heading"+dato.id;
    function cambio(event:any)
    {

        dispatch({type:"cambio",input:{
        name:event.target.name,
        value:event.target.value
      }})
    }
    function reducer(state:any,action:any)
    {
      switch(action.type)
      {
        
        case "cambio":return {
          ...state,[action.input.name]:action.input.value
        }
        case "Reinicio":
          {
            return {valor:0,descripcion:""}
        }
          
         
      }
    
      return state;
    }
    const aceptar=()=>
    {
        if(confirmar())
        {
            var body=
            {
                "guiahija" : dato.guia,
                "valor" : states.valor,
                "ecode" : Cli.lCasilla[Cli.Eleccion].ecode,
                "observacion" : states.descripcion,
                "nombre" : Cli.nombre,
                "email" :Cli.email,
                "factura" :Url,
                "descripcion" : states.descripcion
            }
            const SubirFac=Post2(cuentaCliente.SubirFactura,JSON.stringify(body),"application/json",tok)
            SubirFac.then(resultado=>
                {
                    SetMensajeEmergente(resultado);
                    if(resultado=="Archivo subido con éxito.")
                    {
                        SetActivo(false);
                        const dato2=Get(Carga.Notificaciones.replace("@rut",Cli.rut+"").replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode),"application/json",tok)
                        dato2?.then(resultado=>ActualizarNotificacion(resultado))

                    }
                    
                })
        }
        SetLoading(false)
    
    }

    const confirmar=()=>
    {
        if(states.valor<=0)
        {
            SetMensajeEmergente("Ingrese un valor de factura mayor a 0")
            return false;
        }
        if(Url == "")
        {
            SetMensajeEmergente("Ingrese una factura con los formatos requeridos y no mayor a 1.5MB")
            return false;
        }

        return true;
    }

    const SubirFactura=(e:any)=>
      {
        const tiempo=Date.now();
        const hoy = new Date(tiempo);
        
          var files = e.target.files[0]
          
          if(files.size<=1600000)
          {
            var extencion=files.name.toLowerCase()
              if(extencion.includes(extension1) || extencion.includes(extension2) || extencion.includes(extension3) || extencion.includes(extension4) || extencion.includes(extension5))
              {
                  var arreglo=extencion.split(".");
                  var formdata = new FormData();
                  var nombre="Factura_"+dato.guia+"_"+hoy.getFullYear()+"-"+VariableFecha(hoy.getMonth())+"-"+VariableFecha(hoy.getDay())+"_"+hoy.getHours()+"-"+hoy.getMinutes()+"."+arreglo[arreglo.length-1]
                  formdata.append("", files, nombre);
                  const dato3=PostSinContent(cuentaCliente.SubirImagenFactura,formdata,tok)
                              dato3.then(resultado=>{
                                  SetUrl(resultado);
                                  SetLoading(false);
                              })
              }else
              {
                  SetUrl("")
                  SetMensajeEmergente("Ingrese una factura con los formatos requeridos")
              }
          }
          else
          {
              SetUrl("")
              SetMensajeEmergente("Tamaño del Archivo es mayor a 1.5MB ")
          }
          SetLoading(false);

      }

      const VariableFecha=(variable:number)=>
        {
            if(variable>=1 && variable<=9)
                {
                    return "0"+variable;
                }else
                {
                    return variable
                }
        }

    return(
        <>
        <div className="accordion-item" key={dato.guia} >
                            <h2 className="accordion-header" id={idHeading}>
                                <button className={GuiaBusquedaPreAlerta==dato.guia?"accordion-button":"accordion-button collapsed"}   type="button" data-bs-toggle="collapse" data-bs-target={"#"+collapseId} aria-expanded={GuiaBusquedaPreAlerta==dato.guia?"true":"false"}  aria-controls={collapseId}>Adjunta tu factura para la Guia N° {dato.guia} </button>
                            </h2>
                            <div id={collapseId} className={GuiaBusquedaPreAlerta==dato.guia?"accordion-collapse collapse show":"accordion-collapse collapse"}  aria-labelledby={idHeading} >
                                <div className="card-body">
                                    <h5>Guia : {dato.guia}</h5>
                                    <h6>Descripcion : {dato.contenido[3].value}</h6>
                                    {Activo?<><strong>Consideraciones antes de subir una factura:</strong>
          
          <ul>
              <li>Sólo se admiten archivos con extensión .doc, .docx, .jpg, .png y .pdf</li>
              <li>El tamaño no debe superar los 1,5mb</li>
          </ul>
          <div className="row pt-1 pt-sm-3">
              <div className="col-12 col-sm-6">
                  <div className="mb-3">
                  <label className="form-label">Monto en $USD</label>
                  <input className="col-12 col-m-8" name="valor" type="number" onChange={cambio} autoFocus={GuiaBusquedaPreAlerta==dato.guia?true:false}></input>
                      <p className="small py-1">Utiliza punto para decimales (E.g. 19.99)</p>
                  </div>
                  <div className="mb-3">
                  <input className="col-12 col-m-8" name="descripcion" placeholder="Observaciones" onChange={cambio}></input>
                  </div>
                  <div className="mb-3">
                      <label className="form-label">Subir Factura</label>
                      <br/>
                      <input type="file" onChange={SubirFactura} />
                  </div>
                  <div className="col-auto">
                      <input type="button" className="btn btn-success" id="enviarFactura" value="Subir Factura" onClick={()=>{SetLoading(true);aceptar();}} disabled={Url==""?true:false}/>
                  </div>
              </div>
          </div>
                                    </>:<>
                                    <strong>Esta Guia ya contiene un Documento adjunto</strong>
                                    <br/>
                                    <strong>Si hubo algun problema con el documento adjunto</strong>
                                    <ul>
                                        <li>contactarse con info@eshopex.cl o +562 2368 0900</li>
                                    </ul></>}
                                    
                                </div>
                            </div>
                            </div>  
                      
        </>
    )
}